export enum ParameterType {
    DEFAULT = "default",
    STRING = "string",
    BOOLEAN = "boolean",
    DATE = "date",
    INT = "int",
    FLOAT = "float",
    ARRAY = "list",
}

export enum ParameterStatus {
    ACTIVE = "active",
    INACTIVE = "inactive"
}

export interface IMetaParameter {
    name: string;
    type: ParameterType;
    description: string;
};